module.exports = __webpack_public_path__ + "img/lunchly_menu2.52f69aaa.png";